import { render, staticRenderFns } from "./VideoSliderBar.vue?vue&type=template&id=5cf27f39&scoped=true&"
import script from "./VideoSliderBar.vue?vue&type=script&lang=ts&"
export * from "./VideoSliderBar.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSliderBar.vue?vue&type=style&index=0&id=5cf27f39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf27f39",
  null
  
)

export default component.exports